exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overflow-on .cell[data-v-3fa4825c]{overflow:visible;overflow-x:visible;overflow-y:visible}.el-table__row button[data-v-3fa4825c]{margin:5px}\n", ""]);

// exports
